/** layout 视口底 → 物理屏底的延伸高度（CSS 变量名） */
export const BLEED_BOTTOM_VAR = "--lf-h5-bleed-bottom";
/** 物理屏高度（CSS 变量名，= innerHeight + bleed） */
export const SCREEN_HEIGHT_VAR = "--lf-h5-screen-height";

function measureSafeAreaBottomPx(): number {
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:fixed;visibility:hidden;pointer-events:none;padding-bottom:env(safe-area-inset-bottom)";
  document.documentElement.appendChild(probe);
  const px = parseFloat(getComputedStyle(probe).paddingBottom) || 0;
  probe.remove();
  return Math.round(px);
}

function measureScreenCssHeightPx(): number {
  const sw = window.screen.width;
  const sh = window.screen.height;
  const portrait = window.innerHeight >= window.innerWidth;
  return portrait ? Math.max(sh, sw) : Math.min(sh, sw);
}

function isIosLike(): boolean {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

/**
 * layout 底到物理屏底需向下延伸的高度。
 * env(safe-area-inset-bottom) 通常只有 Home 条（如 34px），
 * screen.height - innerHeight 才是完整差值（如 62px）。
 */
export function measureBleedBottomPx(): number {
  const fromEnv = measureSafeAreaBottomPx();
  const inner = window.innerHeight;
  const fromScreen = Math.max(0, measureScreenCssHeightPx() - inner);
  if (isIosLike() && fromScreen > 0) {
    return Math.max(fromEnv, fromScreen);
  }
  return fromEnv;
}

/** 写入物理屏高度到 html；iOS fixed 层绘制不跟 box 高度走，须用文档流 */
export function applyViewportFill(): void {
  const bleed = measureBleedBottomPx();
  const screenHeight = window.innerHeight + bleed;
  const doc = document.documentElement;
  const px = `${screenHeight}px`;
  doc.style.setProperty(BLEED_BOTTOM_VAR, `${bleed}px`);
  doc.style.setProperty(SCREEN_HEIGHT_VAR, px);
  doc.style.height = px;
}

export function initViewportFill(): () => void {
  applyViewportFill();
  const refresh = () => applyViewportFill();
  window.addEventListener("resize", refresh);
  window.addEventListener("orientationchange", refresh);
  window.visualViewport?.addEventListener("resize", refresh);
  return () => {
    window.removeEventListener("resize", refresh);
    window.removeEventListener("orientationchange", refresh);
    window.visualViewport?.removeEventListener("resize", refresh);
  };
}
